import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { clearPaymentSession } from '../services/montyPayService.ts';
import { Theme } from '../lib/theme';
import { FaTimesCircle } from 'react-icons/fa';

const MontyPayCancelPage: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Clear stored payment session data
    clearPaymentSession();
  }, []);

  return (
    <div
      className="min-h-screen flex items-center justify-center p-4"
      style={{
        background: `linear-gradient(to bottom right, 
          ${Theme.colors.gradient.secondary1}, 
          ${Theme.colors.gradient.primary1}, 
          ${Theme.colors.background})`,
      }}
    >
      <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-md w-full text-center">
        <div className="mb-6">
          <div className="bg-yellow-100 rounded-full w-24 h-24 mx-auto flex items-center justify-center">
            <FaTimesCircle className="text-6xl text-yellow-600" />
          </div>
        </div>
        
        <h2 className="text-3xl font-bold text-gray-800 mb-4">
          Payment Cancelled
        </h2>
        
        <p className="text-gray-600 mb-4">
          You have cancelled the payment process.
        </p>
        
        <p className="text-gray-500 mb-8">
          No charges have been made to your account.
        </p>

        <button
          onClick={() => navigate('/new-presentation')}
          className="w-full bg-blue-600 text-white font-semibold py-3 rounded-lg hover:bg-blue-700 transition-colors mb-3"
        >
          Back to Pricing
        </button>

        <button
          onClick={() => navigate('/history')}
          className="w-full bg-gray-100 text-gray-700 font-semibold py-3 rounded-lg hover:bg-gray-200 transition-colors"
        >
          Go to Dashboard
        </button>
      </div>
    </div>
  );
};

export default MontyPayCancelPage;
